import React from 'react';

import { Button } from 'react-bootstrap5';

import IconWithText from 'components/Widgets/IconWithText';

import { useContext } from 'components/Members/Onboarding/Context';

export default function CoachMatch() {
  const { dispatch, state, actions } = useContext();

  const onGoNextClick = () => {
    actions.completeStep(state.steps[state.currentStep].step, () => {
      actions.setNextStep({
        dispatch,
        steps: state.steps,
        isPossibleSkip: false,
        currentStep: state.currentStep,
      });
    });
  };

  return (
    <div className="content onboarding-content">
      <div className="row">
        <div className="col-lg order-lg-last">
          <div className="bg-photo bg-members-onboarding-lsa-intro-photo" />
        </div>
        <div className="col-lg order-lg-first">
          <div className="pt-4 p-sm-4 pe-lg-0 h-100 d-flex flex-column">
            <h1>Learning Style Assessment</h1>

            <p className="mt-5">
              This final assessment identifies your unique learning, interaction,
              and working styles. These results allow our Ai coach matching technology
              to match you to the top 3 best-suited professional coaches within our diverse network.
            </p>

            <IconWithText
              iconClassName="big-icon honesty-icon bg-secondary"
              wrapperClassName="mt-3"
              iconStyle={{ minWidth: '120px' }}
            >
              <h6>97% Coach Match Success Rate</h6>
            </IconWithText>
            <div className="mt-auto">
              <Button
                onClick={onGoNextClick}
                className="d-block d-sm-inline-block mt-4 mt-sm-3"
              >
                Take the Assessment
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
